<div class="container" #container>
  <app-contact-sideswipe class="sideswipe-container"></app-contact-sideswipe>
  <app-account-bubble></app-account-bubble>
  <div class="content" #content>
    <div class="center-column">
      <img class="nowaccount-logo" alt="NowAccount Logo" />
      <div class="header-text">
        <h1 [attr.aria-label]="this.headerText">{{this.headerText}}</h1>
        <app-tool-tip
          [pageContent]="this.tooltip1Content"
          style="align-self: center;"
          #headerTooltipComponent
        ></app-tool-tip>
      </div>
      <app-serverside-alert></app-serverside-alert>
      <div class="textboxes">
        <ng-container [formGroup]="form1">
          <ng-container *ngIf="this.resolveRegisteredCompanyNameText">
            <h3 class="subHeaderForCompanyName">What is your company's registered company name?</h3>
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText={{this.resolveRegisteredCompanyNameText}}
                formControlName="registeredCompanyName"
                inputType="text"
                [parentForm]="form1"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form1.get('registeredCompanyName')?.invalid &&(this.form1.get('registeredCompanyName')?.dirty ||
                 this.form1.get('registeredCompanyName')?.touched)">
              <kendo-formerror *ngIf="this.form1.get('registeredCompanyName')?.errors?.['required']">
                Enter your registered company name
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveHowDidYouHearAboutUsText">
            <h3 class="subHeaderForHearAbout">How did you hear about NowAccount?</h3>
            <app-kendo-dropdown
              [dropdownHeaderText]="this.resolveHowDidYouHearAboutUsText"
              [options]="heardAboutUsOptions"
              formControlName="howDidYouHearAboutUs"
              (selectionChange)="heardAboutUsChange($event)"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div *ngIf=" this.form1.get('howDidYouHearAboutUs')?.invalid &&(this.form1.get('howDidYouHearAboutUs')?.dirty ||
                  this.form1.get('howDidYouHearAboutUs')?.touched)">
              <kendo-formerror *ngIf="this.form1.get('howDidYouHearAboutUs')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                *ngIf="heardAboutUsReferralBit"
                inputText="Referral"
                formControlName="whoReferredYou"
                inputType="text"
                [parentForm]="form1"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form1.get('whoReferredYou')?.invalid &&(this.form1.get('whoReferredYou')?.dirty ||
                  this.form1.get('whoReferredYou')?.touched)">
              <kendo-formerror *ngIf="this.form1.get('whoReferredYou')?.errors?.['required']">
                Enter who referred you
              </kendo-formerror>
            </div>
            <!-- Others -->
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                *ngIf="heardAboutUsOtherBit"
                inputText="Other"
                formControlName="describeHowYouHeardAboutUs"
                inputType="text"
                [parentForm]="form1"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form1.get('describeHowYouHeardAboutUs')?.invalid &&(this.form1.get('describeHowYouHeardAboutUs')?.dirty ||
                  this.form1.get('describeHowYouHeardAboutUs')?.touched)">
              <kendo-formerror *ngIf="this.form1.get('describeHowYouHeardAboutUs')?.errors?.['required']">
                Enter how you heard about us
              </kendo-formerror>
            </div>
          </ng-container>
        </ng-container>

        <ng-container [formGroup]="form2">
          <ng-container *ngIf="this.resolveBusinessIndustryText">
            <h3>What industry is your business in?</h3>
            <app-kendo-dropdown
              [dropdownHeaderText]="this.resolveBusinessIndustryText"
              [options]="businessIndustryOptions"
              formControlName="businessIndustry"
              (selectionChange)="businessIndustryChange($event)"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div *ngIf=" this.form2.get('businessIndustry')?.invalid &&(this.form2.get('businessIndustry')?.dirty ||
                  this.form2.get('businessIndustry')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('businessIndustry')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>

            <!-- Others -->
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                *ngIf="businessIndustryOthersBit"
                inputText="Other"
                formControlName="businessIndustryOthers"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form2.get('businessIndustryOthers')?.invalid &&(this.form2.get('businessIndustryOthers')?.dirty ||
                  this.form2.get('businessIndustryOthers')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('businessIndustryOthers')?.errors?.['required']">
                Enter your business industry
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveCustomerTypeText">
            <h3>What type of customer do you do business with?</h3>
            <!-- <app-kendo-dropdown 
                            [dropdownHeaderText]="this.resolveCustomerTypeText"
                            [options]="customerTypeOptions" 
                            formControlName="customerTypes"
                            (selectionChange)="customerTypeChange($event)"
                        ></app-kendo-dropdown> -->
            <div style="padding-top: 10px;">
              <app-kendo-checkbox-group
                [options]="customerTypeOptions"
                cssClass="stack"
                (outputParameter)="handleCustomerTypesOutput($event)"
              ></app-kendo-checkbox-group>
            </div>
            <div *ngIf=" this.form2.get('customerType')?.invalid &&(this.form2.get('customerType')?.dirty ||
                  this.form2.get('customerType')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('customerType')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>

            <!-- Others -->
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                *ngIf="customerTypeOthersBit"
                inputText="Other"
                formControlName="customerTypeOthers"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form2.get('customerTypeOthers')?.invalid &&(this.form2.get('customerTypeOthers')?.dirty ||
                  this.form2.get('customerTypeOthers')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('customerTypeOthers')?.errors?.['required']">
                Enter the other customer type
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveStateOfOrgText">
            <h3>What state was your company organized in?</h3>
            <app-kendo-dropdown
              [dropdownHeaderText]="this.resolveStateOfOrgText"
              [options]="stateOptions"
              formControlName="stateOfOrg"
              (selectionChange)="stateOfOrgChange($event)"
              [defaultOption]="defaultStateOfOrg"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div *ngIf=" this.form2.get('stateOfOrg')?.invalid &&(this.form2.get('stateOfOrg')?.dirty ||
                  this.form2.get('stateOfOrg')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('stateOfOrg')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveAddressText">
            <h3>What is your company's address?</h3>
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText="Address1"
                formControlName="address1"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div
                 *ngIf=" this.form2.get('address1')?.invalid &&(this.form2.get('address1')?.dirty ||
                  this.form2.get('address1')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('address1')?.errors?.['required']"
              >
                Enter address's first line
              </kendo-formerror>
            </div>

            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText="Address2"
                formControlName="address2"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div
              *ngIf=" this.form2.get('address2')?.invalid &&(this.form2.get('address2')?.dirty ||
                  this.form2.get('address2')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('address2')?.errors?.['required']"
              >
                Enter address's second line
              </kendo-formerror>
            </div>

            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText="City"
                formControlName="city"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div
              *ngIf="this.form2.get('city')?.invalid &&(this.form2.get('city')?.dirty ||
                  this.form2.get('city')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('city')?.errors?.['required']"
              >
                Enter address's city
              </kendo-formerror>
            </div>

            <app-kendo-dropdown
              [dropdownHeaderText]="'State'"
              [options]="stateOptions"
              formControlName="addressState"
              (selectionChange)="addressStateChange($event)"
              [defaultOption]="defaultAddressState"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div
              *ngIf=" this.form2.get('state')?.invalid &&(this.form2.get('state')?.dirty ||
                  this.form2.get('state')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('state')?.errors?.['required']"
              >
                Please choose one of the options
              </kendo-formerror>
            </div>

            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText="Zipcode"
                formControlName="zipCode"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div
              *ngIf=" this.form2.get('zipCode')?.invalid &&(this.form2.get('zipCode')?.dirty ||
                  this.form2.get('zipCode')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('zipCode')?.errors?.['required']"
              >
                Enter address's zipcode
              </kendo-formerror>
              <kendo-formerror
                *ngIf="this.form2.get('zipCode')?.errors?.['pattern']"
              >
                Enter a valid zipcode
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveCompanyURLText">
            <h3>Does your company have a website? (Optional)</h3>
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                inputText="Company Website URL"
                formControlName="website"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div
              *ngIf=" this.form2.get('website')?.invalid &&(this.form2.get('website')?.dirty ||
                  this.form2.get('website')?.touched)"
            >
              <kendo-formerror
                *ngIf="this.form2.get('website')?.errors?.['required']"
              >
                Enter company website URL
              </kendo-formerror>
              <kendo-formerror
                *ngIf="this.form2.get('website')?.errors?.['pattern']"
              >
                Enter a valid URL
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveNumberOfEmployeesText">
            <h3>How many employees does your company have?</h3>
            <app-kendo-dropdown
              [dropdownHeaderText]="this.resolveNumberOfEmployeesText"
              [options]="numberOfEmployeesOptions"
              formControlName="numberOfEmployees"
              (selectionChange)="numberOfEmployeesChange($event)"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div *ngIf=" this.form2.get('numberOfEmployees')?.invalid &&(this.form2.get('numberOfEmployees')?.dirty ||
                  this.form2.get('numberOfEmployees')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('numberOfEmployees')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveLendingMethodText">
            <h3>What type of financial support do you require? Select all that apply.</h3>
            <div style="padding-top: 10px;">
              <app-kendo-checkbox-group
                [options]="lendingMethodOptions"
                cssClass="stack"
                (outputParameter)="handleLendingMethodsOutput($event)"
              ></app-kendo-checkbox-group>
            </div>
          </ng-container>

          <ng-container *ngIf="this.resolveInvoicingMethodText">
            <h3>How does your business invoice?</h3>
            <app-kendo-dropdown
              [dropdownHeaderText]="this.resolveInvoicingMethodText"
              [options]="invoicingMethodOptions"
              formControlName="invoicingMethod"
              (selectionChange)="invoicingMethodChange($event)"
              style="align-self: center;"
            ></app-kendo-dropdown>
            <div *ngIf=" this.form2.get('invoicingMethod')?.invalid &&(this.form2.get('invoicingMethod')?.dirty ||
                  this.form2.get('invoicingMethod')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('invoicingMethod')?.errors?.['required']">
                Please choose one of the options
              </kendo-formerror>
            </div>

            <!-- Others -->
            <div class="signUpTextBoxs">
              <app-kendo-textbox
                *ngIf="invoicingMethodOthersBit"
                inputText="Other"
                formControlName="invoicingMethodOthers"
                inputType="text"
                [parentForm]="form2"
                style="align-self: center;"
              ></app-kendo-textbox>
            </div>
            <div *ngIf=" this.form2.get('invoicingMethodOthers')?.invalid &&(this.form2.get('invoicingMethodOthers')?.dirty ||
                  this.form2.get('invoicingMethodOthers')?.touched)">
              <kendo-formerror *ngIf="this.form2.get('invoicingMethodOthers')?.errors?.['required']">
                Enter the other customer type
              </kendo-formerror>
            </div>
          </ng-container>

          <div class="signUpTextBoxs">
            <div class="button-wrapper">
              <app-stateful-primary-button
                type="submit"
                text="Next"
                [pageUrl]="this.nextState['pageUrl']"
                [stateId]="this.nextState['id']"
                [clickEvent]="this.submit.bind(this)"
                style="align-self: center;"
              ></app-stateful-primary-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
